import {
  Notification,
  NotificationReadBatchUpdateItem,
  NotificationReadBatchUpdateResponse,
} from "@fixa/notifications";
import { httpClient } from "@coworker/http-client";

function getService() {
  return httpClient.notifications;
}

export const setMessageNotificationAsRead = async (notificationId: string) => {
  return await getService().put<Notification>(
    `/notifications/messages/read/${encodeURIComponent(notificationId)}`,
    { body: { read: true } }
  );
};

export const setAllMessageNotificationAsRead = async (
  notificationIds: string[]
) => {
  const readAndIdList: NotificationReadBatchUpdateItem[] = notificationIds.map(
    (notificationId) => ({
      notificationId,
      read: true,
    })
  );

  const data = await getService().put<NotificationReadBatchUpdateResponse>(
    `/notifications/messages/read/batch`,
    { body: readAndIdList }
  );

  if (data.failed.length) {
    console.error(
      "Notifications: setAllMessageNotificationAsRead failed",
      JSON.stringify(data.failed)
    );
  }
  return data;
};
